import BLAKE2s from 'blake2s-js';
export var fireAnalyticsEvent = function fireAnalyticsEvent(_ref) {
  var _ref$event = _ref.event,
    event = _ref$event === void 0 ? 'cbTrackEvent' : _ref$event,
    _ref$eventKey = _ref.eventKey,
    eventKey = _ref$eventKey === void 0 ? 'track-page' : _ref$eventKey,
    _ref$sourceApp = _ref.sourceApp,
    sourceApp = _ref$sourceApp === void 0 ? 'myAp' : _ref$sourceApp,
    _ref$eventData = _ref.eventData,
    eventData = _ref$eventData === void 0 ? {} : _ref$eventData,
    _ref$testing = _ref.testing,
    testing = _ref$testing === void 0 ? false : _ref$testing,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var analyticsEvent = {
    event: event,
    eventInfo: {
      sourceApp: sourceApp,
      eventKey: eventKey,
      eventData: eventData
    }
  };
  if (testing) {
    var _eventData$appPage, _eventData$appPage2, _eventData$appPage3, _eventData$appPage4, _eventData$appPage5, _eventData$appPage6, _eventData$appPage7, _eventData$appPage8;
    console.log("!!! Testing analytics event: ".concat(eventData !== null && eventData !== void 0 && (_eventData$appPage = eventData.appPage) !== null && _eventData$appPage !== void 0 && _eventData$appPage.domain ? "".concat(eventData === null || eventData === void 0 || (_eventData$appPage2 = eventData.appPage) === null || _eventData$appPage2 === void 0 ? void 0 : _eventData$appPage2.domain, "|") : '').concat(eventData !== null && eventData !== void 0 && (_eventData$appPage3 = eventData.appPage) !== null && _eventData$appPage3 !== void 0 && _eventData$appPage3.group ? "".concat(eventData === null || eventData === void 0 || (_eventData$appPage4 = eventData.appPage) === null || _eventData$appPage4 === void 0 ? void 0 : _eventData$appPage4.group, "|") : '').concat(eventData !== null && eventData !== void 0 && (_eventData$appPage5 = eventData.appPage) !== null && _eventData$appPage5 !== void 0 && _eventData$appPage5.page ? "".concat(eventData === null || eventData === void 0 || (_eventData$appPage6 = eventData.appPage) === null || _eventData$appPage6 === void 0 ? void 0 : _eventData$appPage6.page, "|") : '').concat(eventData !== null && eventData !== void 0 && (_eventData$appPage7 = eventData.appPage) !== null && _eventData$appPage7 !== void 0 && _eventData$appPage7.view ? "".concat(eventData === null || eventData === void 0 || (_eventData$appPage8 = eventData.appPage) === null || _eventData$appPage8 === void 0 ? void 0 : _eventData$appPage8.view, "|") : ''), analyticsEvent);
  } else if (!disabled) {
    window.adobeDataLayer = window.adobeDataLayer || [];
    window.adobeDataLayer.push(analyticsEvent);
  }
};
export var encryptID = function encryptID(id) {
  if (!id) return null;
  var encrypted = new BLAKE2s(6);
  var converted = Array.from(id).map(function (l) {
    return l.charCodeAt(0);
  });
  return encrypted.update(converted).hexDigest();
};